import React from 'react';
import './index.css';
import ReactDOM from 'react-dom';
import App from './App' 


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
